import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/skills.json";

export const useSkills = () => useSourceFlowCollection(data);

export default useSkills();